import React from 'react';

function Stats() {
  return (
    <div>
      <h1>Statistiques</h1>
      <p>Page en construction</p>
    </div>
  );
}

export default Stats;
